/* jshint esversion: 6 */

const cleanBaseUrl = (value) => String(value || '').trim().replace(/\/+$/, '');

const normalizeBackendBase = (value) => {
  const cleaned = cleanBaseUrl(value);
  return cleaned.replace(/\/api$/i, '');
};

/**
 * Resolves the backend base URL (without trailing slash).
 * Driven 100% by environment variables (REACT_APP_BACKEND_BASE_URL / REACT_APP_API_BASE_URL).
 * No hardcoded domain URLs required in this file.
 */
export const getBackendBaseURL = () => {
  const envBase =
    process.env.REACT_APP_BACKEND_BASE_URL ||
    process.env.REACT_APP_API_BASE_URL;

  const runtimeBase =
    typeof localStorage !== 'undefined'
      ? localStorage.getItem('gomeet_backend_base_url') || localStorage.getItem('gomeet_api_base_url')
      : null;

  const configuredBase = normalizeBackendBase(envBase || runtimeBase);

  if (configuredBase) {
    return configuredBase;
  }

  if (typeof window === 'undefined') {
    return 'http://localhost:3001';
  }

  const { protocol, hostname, origin } = window.location;

  if (protocol === 'https:') {
    return origin;
  }

  return `http://${hostname || 'localhost'}:3001`;
};

/**
 * Returns the backend API base URL ending with a trailing slash.
 * E.g., "http://localhost:3001/api/"
 */
export const getApiBaseURL = () => {
  const base = getBackendBaseURL();
  return `${base.replace(/\/+$/, '')}/api/`;
};

/**
 * Returns the Socket.io server base URL (without trailing slash).
 * E.g., "http://localhost:3001"
 */
export const getSocketBaseURL = () => {
  return getBackendBaseURL();
};
